import store from '@/store';
import { RouteNames } from '@/data/routes';
import { RouteLocation, NavigationGuardNext } from 'vue-router';
import NotFoundPage from '@/pages/not-found/NotFoundPage.vue';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: '/not-found',
  name: RouteNames.NOT_FOUND.INDEX,
  alias: '/:pathMatch(.*)*',
  component: NotFoundPage,
  meta: {
    displayNav: true,
  },
  beforeEnter(
    _to: RouteLocation,
    _from: RouteLocation,
    next: NavigationGuardNext,
  ) {
    if (store.getters.userIsLoggedIn) {
      return next();
    }
    return next({ name: RouteNames.HOME.INDEX });
  },
});
